import { forwardRef } from 'react'
import classNames from 'classnames'
import type { ComponentPropsWithRef } from 'react'
import type { CommonProps } from '../@types/common'

export interface TrProps extends ComponentPropsWithRef<'tr'>, CommonProps {}

const Tr = forwardRef<HTMLTableRowElement, TrProps>((props, ref) => {
    const { children, className, ...rest } = props

    const trClass = classNames(className)

    return (
        <tr ref={ref} className={trClass} {...rest}>
            {children}
        </tr>
    )
})

Tr.displayName = 'Tr'

export default Tr 